import React from 'react'
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Copy, Save } from 'lucide-react';

interface IDraftGeneratedSection {
  isMyLoading: boolean,
  copySuccess: boolean,
  userId: string,
  generatedEmail: string,
  handleCopy: () => void,
  handleSaveDraft: () => Promise<void>
}

function DraftGeneratedSection({ isMyLoading, copySuccess, userId, generatedEmail, handleCopy, handleSaveDraft }: IDraftGeneratedSection) {
  return (
    <Card className="shadow-xl dark:bg-gray-800">
      <CardHeader className="border-b dark:border-gray-700">
        <CardTitle className="text-xl text-indigo-600">Generated Draft</CardTitle>
        <CardDescription>The AI-generated email is ready for review.</CardDescription>
      </CardHeader>
      <CardContent className="p-6">
        <div className="relative">
            {generatedEmail ? (
                <Textarea 
                    readOnly 
                    value={generatedEmail} 
                    rows={20} 
                    className="min-h-[400px] font-mono text-sm dark:bg-gray-700 dark:border-gray-600"
                />
            ) : (
                <div className="min-h-[400px] border border-dashed border-gray-300 dark:border-gray-600 rounded-lg flex items-center justify-center text-gray-500 italic dark:text-gray-400 p-4">
                    {isMyLoading ? 'The AI is composing the perfect email...' : 'Your draft will appear here after generation.'}
                </div>
            )}
        </div>
        
        <div className="flex flex-col lg:flex-row justify-end mt-4 space-x-3">
            <Button 
                variant="outline"
                onClick={handleCopy}
                disabled={!generatedEmail}
                className="flex items-center space-x-2"
            >
                <Copy className="h-4 w-4" />
                <span>{copySuccess ? 'Copied!' : 'Copy to Clipboard'}</span>
            </Button>
            
            <Button className="bg-sky-500 hover:bg-sky-600 text-white flex items-center space-x-2" 
              disabled={!generatedEmail || !userId}
              onClick={handleSaveDraft}
            >
                <Save className="h-4 w-4" />
                <span>Save Draft</span>
            </Button>
            {/* </form> */}
        </div>
      </CardContent>
    </Card>
  )
}

export default DraftGeneratedSection